import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, GeoJSON, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icon issue in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Component to handle map clicks
function MapClickHandler({ onMapClick }) {
  const map = useMap();

  useEffect(() => {
    const handleClick = (e) => {
      onMapClick(e.latlng);
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, onMapClick]);

  return null;
}

function Map({ geojsonPath, onMapClick, guessLocation, showAnswer }) {
  const [geojsonData, setGeojsonData] = useState(null);

  useEffect(() => {
    if (geojsonPath) {
      fetch(geojsonPath)
        .then(res => res.json())
        .then(data => setGeojsonData(data))
        .catch(err => console.error('Error loading GeoJSON:', err));
    }
  }, [geojsonPath]);

  const geojsonStyle = {
    fillColor: '#FF6B6B',
    fillOpacity: showAnswer ? 0.4 : 0,
    color: '#FF6B6B',
    weight: showAnswer ? 2 : 0,
  };

  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      style={{ height: '100%', width: '100%' }}
      minZoom={2}
      maxZoom={8}
      worldCopyJump={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {showAnswer && geojsonData && (
        <GeoJSON data={geojsonData} style={geojsonStyle} />
      )}

      {guessLocation && (
        <Marker position={[guessLocation.lat, guessLocation.lng]} />
      )}

      {!showAnswer && <MapClickHandler onMapClick={onMapClick} />}
    </MapContainer>
  );
}

export default Map;
